import _ from 'lodash';
import Emitter from '../../services/emitter';
import CONSTANT from '../../constant';

export const UPLOAD_FIRMWARE = 'UPLOAD_FIRMWARE';
export const UPLOAD_READY = 'UPLOAD_READY';
export const UPLOAD_CODE = 'UPLOAD_CODE';
export const UPLOAD_CODE_PROGRESS = 'UPLOAD_CODE_PROGRESS';
let interval = null;

const uploadState = (type) => {
    return {
        type: type,
        payload: {
            progress_status: CONSTANT.UPLOAD_STATUS.READY,
            progress_percent: 0
        }
    };
};

export const uploadFirmwarePrepare = () => {
    return uploadState(UPLOAD_FIRMWARE);
};

const uploadFirmwareProgress = (percent) => {
    return {
        type: UPLOAD_FIRMWARE,
        payload: {
            progress_status: CONSTANT.UPLOAD_STATUS.PROCESSING,
            progress_percent: percent
        }
    };
};

const uploadFirmwareFinished = () => {
    return {
        type: UPLOAD_FIRMWARE,
        payload: {
            progress_status: CONSTANT.UPLOAD_STATUS.UPLOADED,
            progress_percent: 100
        }
    };
};

const uploadFirmwareFail = () => {
    return {
        type: UPLOAD_FIRMWARE,
        payload: {
            progress_status: CONSTANT.UPLOAD_STATUS.FAILED,
            progress_percent: 0
        }
    };
};

/**
 * 设置上传代码状态
 *
 * @param {any} type
 * @param {any} successCb
 * @param {any} failCb
 * @returns
 */
const setUploadState = (type, successCb, failCb) => {
    const state = uploadState(type);
    const result = (err, data) => {
        console.log(data);
        if (err) {
            state.payload.progress_status = CONSTANT.UPLOAD_STATUS.FAILED;
            Emitter.emit('UploadCodeFail');
            clearInterval(interval);
            _.isFunction(failCb) && failCb();
        } else {
            checkTimeout(state);
            if (data.type == 'progress') {
                const percent = parseInt(data.percent);
                state.payload.progress_percent = percent;
                state.payload.progress_status = CONSTANT.UPLOAD_STATUS.PROCESSING;
            } else if (data.type == 'finish') {
                clearInterval(interval);
                state.payload.progress_percent = 100;
                state.payload.progress_status = CONSTANT.UPLOAD_STATUS.UPLOADED;
                Emitter.emit('UploadedCode');
                _.isFunction(successCb) && successCb();
            }
        }
        return state;
    };
    return {
        state, result
    };
};

const checkTimeout = (state) => {
    // 排除 hid 这一类连接
    let editingTarget = Mscratch.instance.extensions.getEditingTarget();
    if (editingTarget && editingTarget.config.shouldConnect && editingTarget.config.shouldConnect.length
        || !editingTarget.config.shouldConnect) {
        for (let item of editingTarget.config.shouldConnect) {
            if(item === 'hid') {
                clearInterval(interval);
                return false;
            }
        }
    }
    let count = 0, lastPercent = 0, maxCount = 5;
    clearInterval(interval);
    interval = setInterval(() => {
        let percent = state.payload.progress_percent;
        if(percent === 100 ) {
            clearInterval(interval);
            return;
        }

        if (count > maxCount) {
            clearInterval(interval);
            Emitter.emit('UploadCodeFail');
            return;
        }

        if(lastPercent !== percent) {
            lastPercent = percent;
        } else {
            count++;
        }
    }, 1000);
};


/**
 * 准备上传代码
 *
 * @returns
 */
const uploadCodePrepare = () => {
    return uploadState(UPLOAD_READY);
};

/**
 * 上传代码
 *
 * @param {any} successCb
 * @param {any} failCb
 * @returns
 */
const uploadCode = () => {
    const upload = setUploadState(UPLOAD_CODE);
    return dispatch => {
        dispatch(upload.state);
    };
};

/**
 * 上传代码进度
 *
 * @param {any} err
 * @param {any} data
 * @returns
 */
const uploadCodeProgress = (err, data) => {
    const upload = setUploadState(UPLOAD_CODE_PROGRESS);
    if (err) {
        return upload.result(err);
    }
    return upload.result(null, data);
};

const uploadCodeFail = () => {
    const state = uploadState(UPLOAD_CODE);
    state.payload.progress_status = CONSTANT.UPLOAD_STATUS.FAILED;
    return dispatch => {
        dispatch(state);
    };
};

export default {
    uploadFirmwarePrepare,
    uploadFirmwareProgress,
    uploadFirmwareFinished,
    uploadFirmwareFail,
    uploadCodePrepare,
    uploadCode,
    uploadCodeFail,
    uploadCodeProgress,
};